module.exports = __webpack_public_path__ + "img/world_map.35c46a13.jpg";